import React, { Component, type ReactNode } from 'react';
import type { ItemGroup } from '../../../model/index.tsx';
import ErrorView from './error/view.tsx';
import MenuListContent from './menu-list-content/view.tsx';

type Props = {
	isLoading: boolean;
	isError: boolean;
	listHeading: string;
	options: ItemGroup[];
	children: ReactNode | null;
	errorMessage: string;
	onBeforeLoading: (arg1: { height: number }) => void;
	onRetry: () => void;
};

// eslint-disable-next-line jira/react/no-class-components
export default class MenuList extends Component<Props> {
	renderMenuListContent() {
		const { onBeforeLoading, ...props } = this.props;
		return <MenuListContent {...props} />;
	}

	renderError() {
		const { errorMessage, onRetry } = this.props;
		return <ErrorView errorMessage={errorMessage} onRetry={onRetry} />;
	}

	render() {
		const { isError } = this.props;
		return isError ? this.renderError() : this.renderMenuListContent();
	}
}
